var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizem3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.916 17H1.224V8.198H2.736L2.898 9.35C3.348 8.522 4.284 7.946 5.526 7.946C6.894 7.946 7.866 8.63 8.316 9.728C8.73 8.63 9.792 7.946 11.16 7.946C13.176 7.946 14.4 9.206 14.4 11.24V17H12.744V11.654C12.744 10.268 11.97 9.476 10.782 9.476C9.504 9.476 8.658 10.376 8.658 11.78V17H6.984V11.636C6.984 10.25 6.228 9.494 5.04 9.494C3.762 9.494 2.916 10.376 2.916 11.78V17Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.048 7.008H17.472V6.488L19.112 4.912H16.512V4.216H20.104V4.848L18.52 6.36C19.504 6.48 20.248 7.144 20.248 8.184C20.248 9.352 19.368 10.096 18.192 10.096C17.056 10.096 16.24 9.4 16.24 8.2H17.016C17.016 8.952 17.48 9.392 18.208 9.392C18.96 9.392 19.448 8.912 19.448 8.168C19.448 7.472 18.968 7.008 18.048 7.008Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizem3);
export default __webpack_public_path__ + "static/media/sizem3.e4328c4f1657d66fdabdd5c954032a5a.svg";
export { ForwardRef as ReactComponent };